import styles from "./Evaluation.module.css";
import { BlueButton } from "@react-solutions-ui/findmore-ui";
import { IMyPendingEvaluation } from "../../Interfaces/IHomeInterface";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../../context/UserContext";

interface Props {
  data: IMyPendingEvaluation[];
  loading?: boolean;
}

export default function EvaluateColleaguesList({ data }: Props) {
  const navigate = useNavigate();
  const { user } = useUser();
  const canViewProfile =
    user?.typeLabel === "Team Leader" ||
    user?.typeLabel === "Management" ||
    user?.typeLabel === "RH";

  const calcDaysRemaining = (endDate: string) => {
    const end = new Date(endDate);
    const now = new Date();
    const diff = Math.ceil(
      (end.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
    );
    return diff;
  };

  const getDaysRemainingText = (endDate: string) => {
    const diff = calcDaysRemaining(endDate);
    if (diff > 0) return `${diff} dias restantes`;
    return "Prazo expirado";
  };

  return (
    <div className={styles.container}>
      <div>
        <h2 className={styles.title}>AVALIAR COLEGA</h2>
        <p className={styles.subtitle}>Avalia colegas que te convidaram</p>
      </div>

      {data.map((item) => {
        const daysRemaining = calcDaysRemaining(item.endDate);

        return (
          <div key={item.employeeId} className={styles.card}>
            <div className={styles.info}>
              {daysRemaining <= 5 && (
                <span className={styles.daysLeft}>
                  {getDaysRemainingText(item.endDate).toUpperCase()}
                </span>
              )}
              {canViewProfile ? (
                <button
                  className={`${styles.name} ${styles.clickableName}`}
                  onClick={() =>
                    navigate(`/profile-team/${item.evaluatedEmployeeId}`)
                  }
                >
                  {item.personName}
                </button>
              ) : (
                <span className={styles.name}>{item.personName}</span>
              )}
              <span className={styles.role}>{item.areaName}</span>
            </div>

            <BlueButton
              text="AVALIAR"
              onClick={() => navigate(`/questionnaire?id=${item.evaluatorId}`)}
              className={styles.evaluateBtn}
            />
          </div>
        );
      })}
    </div>
  );
}
